import { FC } from 'react'
import { useToggle } from 'react-use'
import PrimaryButton from '@organisms/PrimaryButton'
import { CloseWrapper, TextWrapper, Wrapper } from './styled'

const InfoBanner: FC = () => {
  const closable = process.env.REACT_APP_BANNER_CLOSABLE === 'true'
  const bannerLink = process.env.REACT_APP_BANNER_LINK
  const text = process.env.REACT_APP_BANNER_TEXT
  const [visible, toggleVisible] = useToggle(!!text)

  const handleLinkClick = () => {
    window.open(bannerLink, '_blank')
  }

  if (!visible || !text) return null

  return (
    <Wrapper className="popover">
      <TextWrapper
        className="popover"
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {!!bannerLink && (
        <PrimaryButton className="popover" onClick={handleLinkClick}>
          Смотреть
        </PrimaryButton>
      )}
      {closable && (
        <CloseWrapper className="popover" onClick={toggleVisible}>
          X
        </CloseWrapper>
      )}
    </Wrapper>
  )
}

export default InfoBanner
